import { render, staticRenderFns } from "./PromotedGridBuyBox.vue?vue&type=template&id=27dd734f&scoped=true"
import script from "./PromotedGridBuyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotedGridBuyBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotedGridBuyBox.vue?vue&type=style&index=0&id=27dd734f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd734f",
  null
  
)

export default component.exports